import { api } from '../../../../lib/api';

export const employeeService = {
  // Cargar empleados (siempre con detalles completos)
  async getEmployees(factoryBase = '', withDetails = true, factoryId = null) {
    // Si se proporciona factoryId numérico, usar el endpoint específico de fábrica
    if (factoryId && Number(factoryId) > 0) {
      const params = new URLSearchParams();
      if (withDetails) params.append('with_details', 'true');
      const data = await api.get(`/api/labor/factory/${factoryId}/employees?${params.toString()}`);
      return Array.isArray(data) ? data : [];
    }

    // Comportamiento anterior: endpoint unificado filtrando por factoryBase
    const params = new URLSearchParams();
    if (factoryBase) params.append('factoryBase', factoryBase);
    params.append('withDetails', withDetails.toString());
    const data = await api.get(`/api/labor/factory/employees?${params.toString()}`);
    return Array.isArray(data) ? data : [];
  },

  // Crear empleado
  async createEmployee(employeeData, factoryId = FACTORY_ID) {
    return await api.post(`/api/labor/factory/${factoryId}/employees`, employeeData);
  },

  // Actualizar empleado
  async updateEmployee(employeeId, employeeData, factoryId = FACTORY_ID) {
    return await api.put(`/api/labor/factory/${factoryId}/employees/${employeeId}`, employeeData);
  },

  // Eliminar empleado
  async deleteEmployee(employeeId, factoryId = FACTORY_ID) {
    return await api.delete(`/api/labor/factory/${factoryId}/employees/${employeeId}`);
  },

  // Workday - Listar empleados
  async getWorkdayEmployees(factory = '') {
    const params = new URLSearchParams();
    if (factory) {
      params.append('factory', factory);
    }
    params.append('active_only', 'true');
    const data = await api.get(`/api/labor/workday/listemployees?${params.toString()}`);
    return Array.isArray(data?.employees) ? data.employees : (Array.isArray(data) ? data : []);
  },

  // Workday - Sincronizar
  async syncWorkday() {
    return await api.post('/api/labor/workday/sync/employees');
  },

  // Workday - Procesar ficheros JSON del directorio configurado
  async processWorkdayFiles() {
    return await api.post('/api/labor/workday/process');
  },

  // Workday - Detalles de empleado
  async getWorkdayEmployeeDetails(wid) {
    const data = await api.get(`/api/labor/workday/employee?wid=${wid}`);
    return data?.employee || null;
  },

  // Asignación de roles - Cargar estructura
  async getFactoryDepartRoles() {
    const data = await api.get('/api/admin/factorydepartroles');
    return Array.isArray(data?.structure) ? data.structure : [];
  },

  // Asignación de roles - Cargar asignaciones de empleado
  async getEmployeeAssignments(employeeId) {
    const data = await api.get(`/api/admin/employees/${employeeId}/assignments`);
    return data?.data || null;
  },

  // Asignación de roles - Asignar un rol individual
  async assignRole(employeeId, factoryId, departmentId, isPrimary, roleName) {
    return await api.post(`/api/admin/employees/${employeeId}/assign-role`, {
      factory_id: factoryId,
      department_id: departmentId,
      is_primary: isPrimary,
      roles: [roleName]
    });
  },

  // Asignación de roles - Eliminar un rol individual
  async unassignRole(employeeId, factoryId, departmentId, roleName) {
    return await api.post(`/api/admin/employees/${employeeId}/unassign-role`, {
      factory_id: factoryId,
      department_id: departmentId,
      roles: [roleName]
    });
  },

  // Asignación de roles - Sincronizar con Authentik
  async syncEmployeeToAuthentik(employeeId) {
    return await api.post(`/api/admin/employees/${employeeId}/sync-authentik`);
  },

  // Skills - Catálogo
  async getSkillsCatalog() {
    const data = await api.get('/api/labor/patterns/skills');
    return Array.isArray(data) ? data : [];
  },

  async createSkill({ name, code, category, description }) {
    return await api.post('/api/labor/patterns/skills', {
      name,
      code,
      category,
      description,
    });
  },

  // Skills - Habilidades de un empleado
  async getEmployeeSkills(employeeId) {
    const data = await api.get(`/api/labor/patterns/skills/employee/${employeeId}`);
    return Array.isArray(data) ? data : [];
  },

  // Skills - Asignar habilidad a empleado
  async assignSkillToEmployee(employeeId, { skillId, level, acquiredAt, expiresAt }) {
    return await api.post(`/api/labor/patterns/skills/assign_to_employee/${employeeId}`, {
      skill_id: skillId,
      level,
      acquired_at: acquiredAt,
      expires_at: expiresAt || null,
    });
  },

  // Skills - Revocar habilidad de empleado
  async revokeEmployeeSkill(assignId) {
    return await api.delete(`/api/labor/patterns/skills/employee/${assignId}`);
  },
};